import styled from '@emotion/styled';

const StyledCheckBox = styled.input`
  width: 20px;
  height: 20px;
  accent-color: black; /* 체크박스의 색상을 검은색으로 설정 */
`;

const StyledTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;
export { StyledCheckBox, StyledTitle };
